import DefaultAnalyticsConfig from "../../../src/common/analytics/defaultAnalyticsConfig";

let erTag = DefaultAnalyticsConfig.erTag;
if (process.env.ENV === "production") {
  erTag = "fc95902161db4473bb018f01d4da6351";
}

export default class AnalyticsConfig extends DefaultAnalyticsConfig {
  //overwrite configs if needed
  static erTag = erTag;
  static erUserReferenceType = "subscriptionReference";

  static cmp = {
    hasPreferenceView: true,
    features: {
      GA: true,
      socialSharing: true,
      ER: true,
    },
    key: "cc4f85a8-c8fa-4cde-a4fe-bc6383fdff93",
    GA: {
      vendorId: "c:googleana-WEX8gGCR",
      purposeId: ["analytics-wQpUtiiC"],
    },
    ER: {
      vendorId: "c:engagerea-3GGx2Gkr",
      purposeId: ["analytics-wQpUtiiC"],
    },
    socialSharing: {
      vendorId: "c:socialsha-mCqZeRf9",
      purposeId: ["utilisatio-CnMhghCF"],
    },
  };
}



// WEBPACK FOOTER //
// ./clients/tec-ldh/js/analyticsConfig.js